import { render, staticRenderFns } from "./cupon.vue?vue&type=template&id=4d5c61cc&scoped=true&"
import script from "./cupon.vue?vue&type=script&lang=js&"
export * from "./cupon.vue?vue&type=script&lang=js&"
import style0 from "./cupon.vue?vue&type=style&index=0&id=4d5c61cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5c61cc",
  null
  
)

export default component.exports